import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import apiService from "../../Common/Configurations/APIService";
import config from '../../Common/Configurations/APIConfig';

export default function WhatsAppCallback() {
    const { search } = useLocation();

    useEffect(() => {
        async function finish() {
            const params = new URLSearchParams(search);
            const code = params.get("code");
            const state = params.get("state");
            const companyId = params.get("companyId"); // if you included it in redirectUri
            console.log(params);
            if (!code || !state) {
                window.close(); // popup: close
                return;
            }

            try {
                const resp = await apiService.getSingle(config.WHATSAPPFINISH + `?code=${code}&state=${state}&companyId=${companyId}`);
                if (resp.data.success) {
                    // show success, close popup and optionally refresh parent
                    window.opener?.postMessage({ type: "whatsapp_connected", data: resp.data.data }, window.origin);
                    window.close();
                } else {
                    console.error(resp.data);
                    alert("Failed to connect WhatsApp: " + resp.data.message);
                    window.close();
                }
            } catch (err) {
                console.error(err);
                alert("Finish signup failed: " + err.message);
                //window.close();
            }
        }
        finish();
    }, [search]);

    return <div>Completing WhatsApp connection... you can close this window.</div>;
}